import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ISettingsService } from "services/SettingsService";
import { TermsAndConditionsModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  TermsAndConditions: new TermsAndConditionsModel(),
  IsLoading: false,
};

export const termsAndConditionsSlice = createSlice({
  name: "TermsAndConditions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTermsAndConditions.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(getTermsAndConditions.fulfilled, (state, action) => {
        state.TermsAndConditions = action.payload;
        state.IsLoading = false;
      })
      .addCase(getTermsAndConditions.rejected, (state) => {
        state.IsLoading = false;
      })
      .addCase(updateTermsAndConditions.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(updateTermsAndConditions.fulfilled, (state) => {
        state.IsLoading = false;
      })
      .addCase(updateTermsAndConditions.rejected, (state) => {
        state.IsLoading = false;
      });
  },
});

export const getTermsAndConditions = createAsyncThunk("TermsAndConditions/GetTermsAndConditions", async () => {
  const termsAndConditionsService = container.get<ISettingsService>(SERVICE_TYPES.SettingsService);
  return await termsAndConditionsService.getTermsAndConditions();
});

export const updateTermsAndConditions = createAsyncThunk(
  "TermsAndConditions/UpdateTermsAndConditions",
  async (updatedContent: string) => {
    const termsAndConditionsService = container.get<ISettingsService>(SERVICE_TYPES.SettingsService);
    return await termsAndConditionsService.updateTermsAndConditions(updatedContent);
  }
);

export const selectTermsAndConditions = (state: RootState) => {
  return state.termsAndConditions.TermsAndConditions;
};

export const selectIsLoading = (state: RootState) => {
  return state.termsAndConditions.IsLoading;
};

export default termsAndConditionsSlice.reducer;
